module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"\" id=\"template-gallery\" style=\"display: none;\">\r\n\r\n    <div class=\"gallery-header\" style=\"height: 35px;\">\r\n    <div class=\"gallery-title\" style=\"float:left\">\r\n        PerfectApps Template Gallery\r\n    </div>\r\n    <div class=\"search\" style=\"float:right;\">\r\n        <input type=\"text\" placeholder=\"Search Templates\" class=\"workspace-filter search-template\" style=\"height: 35px!important;\" id=\"template-search\">\r\n        <div class=\"icon-right clear-templ-search\" title=\"Clear search\" style=\"display: none;right: 22px;top: 11px;\">x</div>\r\n    </div>\r\n</div>\r\n    <hr>\r\n    <div style=\"min-height: 350px;\">\r\n        <div style=\"float: left;width: 20%;\">\r\n            <ul class=\"template-categories\"></ul>\r\n        </div>\r\n        <div id=\"templates-container\" style=\"float:left;width:80%;border-left: 2px solid rgb(197,197,197,.3);\"></div>\r\n        <div class=\"templates-no-results\" style=\"display: none;text-align: center;padding-top: 10%;\">\r\n            <div class=\"title\" style=\"font-size: 16px;\">\r\n                No Results Were Found\r\n            </div>\r\n            <div class=\"more-info\">\r\n                Try adjusting your search or filter to find the template you are looking for.\r\n            </div>\r\n        </div>\r\n    </div>\r\n    \r\n</div>")
  }
  return __output;

}